// App version — sourced from package.json via CRA's built-in JSON import support
// Falls back gracefully when the env var is not set.
import packageJson from '../../package.json';

// Frontend API URL
export const BASE_URL = 'https://aakaashpublications.com/lwtapi/api';

const pkgVersion = packageJson?.version;
export const APP_VERSION = pkgVersion || process.env.REACT_APP_VERSION || '1.0.0';
// Frontend API endpoints
export const API_ENDPOINTS = {
    BASE_URL: `${BASE_URL}`,
    LWT_JOBS: `${BASE_URL}/lwt/jobs`,
    NEWSLETTER_SUBSCRIBE: `${BASE_URL}/newsletter/subscribe`,
    LEADS_SUBMIT: `${BASE_URL}/leads`,
    LEADS_ADMIN_CREATE: `${BASE_URL}/leads/admin/new`,
    PAYU_INITIATE: `${BASE_URL}/payments/payu/initiate`,
    JOBS_APPLY: `${BASE_URL}/jobs/apply`,
    EVENT_FEEDBACK_SUBMIT: `${BASE_URL}/event-feedback`,
    EVENT_FEEDBACK_LIST: `${BASE_URL}/event-feedback`,
    EVENT_FEEDBACK_ADMIN_LIST: `${BASE_URL}/event-feedback/admin`,
    EVENT_FEEDBACK_APPROVE: (id) => `${BASE_URL}/event-feedback/${id}/approve`,
    EVENT_FEEDBACK_DISAPPROVE: (id) => `${BASE_URL}/event-feedback/${id}/disapprove`,
    EVENTS_PAST_IMAGES: `${BASE_URL}/events/images/past`,
    LEADS_ADMIN_ALL: `${BASE_URL}/leads/admin/all`,
    LEADS_ADMIN_DELETE: (id) => `${BASE_URL}/leads/admin/${id}`,
    LEADS_ADMIN_MARKETING_INSIGHTS: `${BASE_URL}/leads/admin/marketing-insights`,
    NEWSLETTER_ADMIN_ALL: `${BASE_URL}/newsletter/admin/all`,
    LEADS_ADMIN_SEND_EMAIL: `${BASE_URL}/leads/admin/sendemail`,
    SURVEYS: `${BASE_URL}/surveys`,
    SURVEY_TAKE: (id) => `${BASE_URL}/surveys/${id}/take`,
    SURVEY_RESPOND: (id) => `${BASE_URL}/surveys/${id}/respond`,
    CAREER_PLANS: `${BASE_URL}/careerplans`,
    RATINGS: `${BASE_URL}/ratings`,
    // Add other endpoints here
};

export const HOME_SURVEY_POPUP = {
    enabled: true,
    surveyIdsCsv: '2',
    surveyId: 2,
    delayMs: 6000,
    dismissForDays: 7,
    hideAfterSubmit: true,
};